import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { applyTz, createUri, Api } from '@api/utils';
import { Query } from './utils';
import { CutAPI } from '@api/cut';

import type { Cut } from '@/types/cuts';
import type { EmployeeCutMaterials } from '@/types/employees';

export const cutHooks = createApi({
    reducerPath: 'cutApi',
    baseQuery: fetchBaseQuery({
        baseUrl: createUri(Api.Cuts, '/cuts/V1'),
    }),
    endpoints: (build) => ({
        // todo: Migrate main CutActivity page to use RTK Query
        // todo: MO-1780
        cutActivity: build.query<
            Cut[],
            {
                token: string;
                pageNum: number;
                pageSize: number;
                startDate?: string;
                endDate?: string;
                employeeEmail?: string;
                locationIds?: string;
                tz?: string;
            }
        >({
            query: ({ token, tz, ...params }) => ({
                url: CutAPI.Activity,
                headers: { Authorization: `Bearer ${token}` },
                params: applyTz(params, tz),
            }),
        }),
        employeeCutMaterials: build.query<
            EmployeeCutMaterials,
            { token: string; LocationID: number; EmployeeEmail: string; startDate?: string; endDate?: string; tz?: string }
        >({
            query: ({ token, tz, ...params }) => ({
                url: CutAPI.MaterialsByEmployee,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: applyTz(params, tz),
            }),
        }),
    }),
});

/** Intermediary Wrapper */
const cut = {
    useCutActivityQuery: Query.withToken(cutHooks.useCutActivityQuery),
    useEmployeeCutMaterialsQuery: Query.withToken(cutHooks.useEmployeeCutMaterialsQuery),
};

export const { useCutActivityQuery, useEmployeeCutMaterialsQuery } = cut;
